module.exports = __webpack_public_path__ + "img/iceland.34c343b3.svg";